/** Whether a sidebar search is active; a term of only spaces does not filter. */
export function isSidebarSearching(term: string): boolean {
  return term.trim() !== "";
}

/** Case-insensitive match of a sidebar label; every label matches while nothing is searched. */
export function matchesSidebarSearch(text: string | null | undefined, term: string): boolean {
  const needle = term.trim().toLowerCase();
  if (needle === "") {
    return true;
  }
  return (text ?? "").toLowerCase().includes(needle);
}
